/*
 * Reliance — Composer du rituel (sections/rel-diagnostic-composer.liquid).
 *  - pastilles : appliquent une fragrance aux 4 soins et à l'eau de parfum ;
 *  - select « Fragrance » d'une carte : change la fragrance de ce seul soin ;
 *  - select « Format » : met à jour le prix affiché ;
 *  - fenêtre « Huile ou lait ? » (<dialog> natif : Échap, focus contenu, clic sur le fond) ; « Prendre l'huile / le lait »
 *    coche l'un et décoche l'autre.
 * E.1r2 : sélection, barre, total, sessionStorage et panier réel sont délégués au module générique
 * assets/rel-selection-cart.js (chargé avant ce fichier). Ce fichier tient à jour, sur chaque carte, les attributs
 * attendus par ce module (data-variant-id, data-price, data-available, data-summary, data-unavailable-label) et lui
 * fournit l'état propre au Composer (fragrance globale, fragrance et format par carte) à sauvegarder et restaurer.
 */
(function () {
  if (window.relComposerInit) return;
  window.relComposerInit = true;

  function parseVariants(el) {
    try {
      return JSON.parse(el.getAttribute('data-variants') || '[]');
    } catch (e) {
      return [];
    }
  }

  function init(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rel-composer-card]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-rel-composer-frag]'));
    var note = root.querySelector('[data-rel-composer-note]');
    var dialog = root.querySelector('[data-rel-composer-compare]');
    var global = root.getAttribute('data-default-fragrance');
    var lastOpener = null;

    function cardFor(role) {
      return cards.filter(function (c) {
        return c.getAttribute('data-role') === role;
      })[0];
    }

    function productOf(card, key) {
      var list = card.querySelectorAll('[data-rel-composer-product]');
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('data-fragrance') === key) return list[i];
      }
      return null;
    }

    function variantOf(card) {
      var product = productOf(card, card.getAttribute('data-fragrance'));
      if (!product) return null;
      var variants = parseVariants(product);
      var format = card.getAttribute('data-format');
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].format === format) return variants[i];
      }
      return variants.length ? variants[variants.length - 1] : null;
    }

    function renderCard(card) {
      var key = card.getAttribute('data-fragrance');
      var product = productOf(card, key);
      var available = !!product && product.getAttribute('data-available') === 'true';
      var variants = product ? parseVariants(product) : [];
      var variant = available ? variantOf(card) : null;

      card.querySelectorAll('[data-rel-composer-product]').forEach(function (el) {
        el.hidden = el !== product;
      });

      var fragSelect = card.querySelector('[data-rel-composer-card-frag]');
      if (fragSelect && fragSelect.value !== key) fragSelect.value = key;

      var formatSelect = card.querySelector('[data-rel-composer-format]');
      if (formatSelect) {
        formatSelect.disabled = !available;
        Array.prototype.forEach.call(formatSelect.options, function (option) {
          var match = variants.filter(function (v) {
            return v.format === option.value;
          })[0];
          if (match) option.textContent = match.label + ' — ' + match.price_label;
        });
        if (variant) formatSelect.value = variant.format;
      }

      var price = card.querySelector('[data-rel-composer-price]');
      if (price) price.textContent = variant ? variant.price_label : product ? product.getAttribute('data-status-label') : '';

      /* Attributs lus par rel-selection-cart.js (la sélection et le bouton « Ajouter » y sont gérés). */
      card.setAttribute('data-available', variant && variant.available !== false ? 'true' : 'false');
      card.setAttribute('data-variant-id', variant ? String(variant.id) : '');
      card.setAttribute('data-price', variant ? String(variant.price) : '0');
      card.setAttribute('data-unavailable-label', product ? product.getAttribute('data-status-label') || '' : '');
      card.setAttribute('data-item-title', product ? product.getAttribute('data-title') || '' : '');
      card.setAttribute(
        'data-summary',
        [card.getAttribute('data-short-name'), product ? product.getAttribute('data-fragrance-name') : '', variant ? variant.label : '']
          .filter(Boolean)
          .join(' ')
      );
    }

    function renderGlobal() {
      var allSame = cards.every(function (c) {
        return c.hasAttribute('data-follows-global') || c.getAttribute('data-fragrance') === global;
      });
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', allSame && chip.getAttribute('data-rel-composer-frag') === global ? 'true' : 'false');
      });
      if (!note) return;
      if (!allSame) {
        note.textContent = note.getAttribute('data-mixed-text') || '';
        return;
      }
      var chip = chips.filter(function (c) {
        return c.getAttribute('data-rel-composer-frag') === global;
      })[0];
      if (!chip) return;
      var text = chip.getAttribute('data-name');
      var notes = chip.getAttribute('data-note');
      var desc = chip.getAttribute('data-desc');
      if (notes) text += ' — ' + notes.toLowerCase() + '.';
      if (desc) text += ' ' + desc;
      note.textContent = text;
    }

    function getState() {
      return {
        fragrance: global,
        cards: cards.map(function (card) {
          var key = card.getAttribute('data-fragrance');
          var product = productOf(card, key);
          var variant = variantOf(card);
          return {
            role: card.getAttribute('data-role'),
            fragrance: key,
            format: card.getAttribute('data-format'),
            selected: card.getAttribute('data-selected') === 'true',
            available: !!product && product.getAttribute('data-available') === 'true',
            variantId: variant ? variant.id : null,
            price: variant ? variant.price : null,
          };
        }),
      };
    }

    function emit() {
      if (root.relSelection) root.relSelection.refresh();
      root.dispatchEvent(new CustomEvent('rel-composer:change', { bubbles: true, detail: getState() }));
    }

    function setFragrance(key) {
      if (!key) return;
      global = key;
      cards.forEach(function (card) {
        card.setAttribute('data-fragrance', key);
        renderCard(card);
      });
      renderGlobal();
      emit();
    }

    function setCardFragrance(role, key) {
      var card = cardFor(role);
      if (!card || !key) return;
      card.setAttribute('data-fragrance', key);
      renderCard(card);
      renderGlobal();
      emit();
    }

    function setFormat(role, format) {
      var card = cardFor(role);
      if (!card || !format) return;
      card.setAttribute('data-format', format);
      renderCard(card);
      emit();
    }

    function openCompare(opener) {
      if (!dialog) return;
      lastOpener = opener || document.activeElement;
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('rel-composer-locked');
    }

    function closeCompare() {
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        onDialogClosed();
      }
    }

    function onDialogClosed() {
      document.documentElement.classList.remove('rel-composer-locked');
      if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
      lastOpener = null;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        setFragrance(chip.getAttribute('data-rel-composer-frag'));
      });
    });

    cards.forEach(function (card) {
      var fragSelect = card.querySelector('[data-rel-composer-card-frag]');
      if (fragSelect) {
        fragSelect.addEventListener('change', function () {
          setCardFragrance(card.getAttribute('data-role'), fragSelect.value);
        });
      }
      var formatSelect = card.querySelector('[data-rel-composer-format]');
      if (formatSelect) {
        formatSelect.addEventListener('change', function () {
          setFormat(card.getAttribute('data-role'), formatSelect.value);
        });
      }
    });

    root.querySelectorAll('[data-rel-composer-compare-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        openCompare(button);
      });
    });

    if (dialog) {
      dialog.addEventListener('close', onDialogClosed);
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeCompare();
      });
      dialog.querySelectorAll('[data-rel-composer-compare-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          closeCompare();
        });
      });
      dialog.querySelectorAll('[data-rel-composer-pick]').forEach(function (button) {
        button.addEventListener('click', function () {
          var pick = button.getAttribute('data-rel-composer-pick');
          var other = pick === 'huile' ? 'lait' : 'huile';
          if (root.relSelection) {
            root.relSelection.select(other, false);
            root.relSelection.select(pick, true);
          }
          closeCompare();
        });
      });
    }

    /* État propre au Composer, sauvegardé avec la sélection (sessionStorage, via rel-selection-cart.js). */
    function saveState() {
      var byRole = {};
      cards.forEach(function (card) {
        byRole[card.getAttribute('data-role')] = {
          fragrance: card.getAttribute('data-fragrance'),
          format: card.getAttribute('data-format'),
        };
      });
      return { fragrance: global, cards: byRole };
    }

    function isKnownFragrance(key) {
      return chips.some(function (chip) {
        return chip.getAttribute('data-rel-composer-frag') === key;
      });
    }

    function restoreState(state) {
      if (!state || typeof state !== 'object') return;
      if (isKnownFragrance(state.fragrance)) setFragrance(state.fragrance);
      var byRole = state.cards || {};
      cards.forEach(function (card) {
        var role = card.getAttribute('data-role');
        var saved = byRole[role];
        if (!saved) return;
        if (!card.hasAttribute('data-follows-global') && isKnownFragrance(saved.fragrance)) {
          setCardFragrance(role, saved.fragrance);
        }
        var select = card.querySelector('[data-rel-composer-format]');
        var validFormat =
          select &&
          Array.prototype.some.call(select.options, function (option) {
            return option.value === saved.format;
          });
        if (validFormat) setFormat(role, saved.format);
      });
    }

    cards.forEach(renderCard);
    if (window.RelSelectionCart) {
      window.RelSelectionCart.init(root, { saveState: saveState, restoreState: restoreState });
    }

    root.relComposer = {
      getState: getState,
      setFragrance: setFragrance,
      setCardFragrance: setCardFragrance,
      setFormat: setFormat,
      openCompare: openCompare,
      closeCompare: closeCompare,
    };
  }

  function boot() {
    document.querySelectorAll('[data-rel-composer]').forEach(function (root) {
      if (root.relComposer) return;
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
